__turbopack_context__.v({
  "className": "dm_sans_8d35c016-module__0Dw4BG__className",
});
